/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One time-series segment for the revenue bar chart.
 * source: 'parking' | 'citations'
 * period: 'primary' | 'compare'
 * counts: parking values are floats; citation values are ints.
 */
export type RevenueCountResponse = {
  source: RevenueCountResponse.source
  period: RevenueCountResponse.period
  counts: Array<number>
  dates: Array<string>
}
export namespace RevenueCountResponse {
  export enum source {
    PARKING = 'parking',
    CITATIONS = 'citations',
  }
  export enum period {
    PRIMARY = 'primary',
    COMPARE = 'compare',
  }
}
